import React from "react"


export type MenuSubConsultasDevolucoesProps = {
    onSelecionadoMenu: () => void;
    onRenderizarFinanceiro: () => void;
    onRenderizarItens: () => void;
}

export const MenuSubConsultasDevolucoes = (props: MenuSubConsultasDevolucoesProps) => {
    return (
        <>
            <h2>Sub-Consultas</h2>

            <ul>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarItens()
                            props.onSelecionadoMenu();
                        }}>
                        Itens
                    </a>
                </li>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarFinanceiro()
                            props.onSelecionadoMenu();
                        }}>
                        Financeiro
                    </a>
                </li>
            </ul>
        </>
    )
}